import { authProviderType } from "@/providers/AuthenticationProvider";

export function isStaffMcpPlaygroundRuntime(): boolean {
  return authProviderType === "okta" || authProviderType === "token";
}

export function canAccessMcpPlayground(viewPeople: boolean, viewFacilities: boolean): boolean {
  return isStaffMcpPlaygroundRuntime() && viewPeople && viewFacilities;
}
